import React, { useMemo } from "react";
import { Select, Row, Col, Form } from "antd";
import { TeamOutlined, FlagOutlined } from "@ant-design/icons";
import { normalizarBusqueda } from "../../shared/normalizarBusqueda";

export const SelectorCliente = ({
  clientesCampanias,
  clienteSeleccionado,
  campaniaSeleccionada,
  onClienteChange,
  onCampaniaChange,
}) => {
  const clienteOptions = useMemo(() => {
    return clientesCampanias.map((cliente) => ({
      value: cliente.clienteID,
      label: cliente.clienteNombre,
    }));
  }, [clientesCampanias]);

  const campaniaOptions = useMemo(() => {
    const cliente = clientesCampanias.find(
      (item) => item.clienteID === clienteSeleccionado
    );
    const campanias = cliente?.campanias || [];
    return campanias.map((campania) => ({
      value: campania.campaniaID,
      label: campania.campaniaNombre,
    }));
  }, [clientesCampanias, clienteSeleccionado]);

  return (
    <Form layout="vertical" size="large">
      <Row gutter={12}>
        <Col xs={24} sm={12}>
          <Form.Item label="Cliente">
            <Select
              placeholder="Seleccione cliente"
              options={clienteOptions}
              value={clienteSeleccionado}
              onChange={onClienteChange}
              showSearch
              suffixIcon={<TeamOutlined />}
              filterOption={(input, option) =>
                normalizarBusqueda(option?.label).includes(normalizarBusqueda(input))
              }
              style={{ width: '100%' }}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12}>
          <Form.Item label="Campaña">
            <Select
              placeholder="Seleccione campaña"
              options={campaniaOptions}
              value={campaniaSeleccionada}
              onChange={onCampaniaChange}
              disabled={!clienteSeleccionado}
              showSearch
              suffixIcon={<FlagOutlined />}
              filterOption={(input, option) =>
                normalizarBusqueda(option?.label).includes(normalizarBusqueda(input))
              }
              style={{ width: '100%' }}
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};
